import { type ReactNode } from 'react';

import { CodeIcon, PencilIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export type WebhookTabKey = 'setup' | 'json';

interface WebhookConfigTabsProps {
  activeTab: WebhookTabKey;
  onTabChange: (value: WebhookTabKey) => void;
  setupContent: ReactNode;
  jsonContent: ReactNode;
}

export default function WebhookConfigTabs({
  activeTab,
  onTabChange,
  setupContent,
  jsonContent,
}: WebhookConfigTabsProps) {
  const { t } = useTranslation();

  return (
    <Tabs
      value={activeTab}
      onValueChange={(value) => onTabChange(value as WebhookTabKey)}
      className="flex h-full flex-col"
    >
      <div className="flex flex-wrap items-center justify-between gap-4">
        <span className="text-lg font-semibold text-foreground">
          {activeTab === 'setup' ? t('webhook.setup_tab_title') : t('webhook.json_tab_title')}
        </span>
        <TabsList>
          <TabsTrigger value="setup" className="gap-2">
            <PencilIcon size={16} />
          </TabsTrigger>
          <TabsTrigger value="json" className="gap-2">
            <CodeIcon size={16} />
          </TabsTrigger>
        </TabsList>
      </div>

      <TabsContent value="setup" className="mt-0 flex h-full flex-col gap-4 overflow-y-auto">
        {setupContent}
      </TabsContent>
      <TabsContent value="json" className="mt-0 flex h-full flex-col gap-4">
        {jsonContent}
      </TabsContent>
    </Tabs>
  );
}
